module.exports = __webpack_public_path__ + "img/shedPoint.cb75560e.png";